export default __webpack_public_path__ + "static/media/plus.3ebd5527.svg";